import hoc, { IconProps } from 'bloko/blocks/icon/hoc';

const DnrScaleSmallAppearanceDefault = hoc(
    (props: IconProps) => (
        <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.34339 2.89581V2.89997C13.2812 2.81182 14.0879 5.38902 14.0879 5.38902C14.7265 6.25723 14.65 9.93966 14.0879 10.7838C14.0879 10.7838 12.8745 13.8067 7.34339 13.825V13.8333H4.4377L4.4377 4.51914L2.89587 3.91871V2.89581L7.34339 2.89581ZM7.3434 12.101L7.3434 4.60638C10.5876 4.29951 11.4034 6.25799 11.4034 6.25799C11.9155 7.60016 11.9155 9.0839 11.4034 10.4261C11.4034 10.4261 10.9535 12.511 7.3434 12.101Z"
                fill="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            />
        </svg>
    ),
    'Dnr'
);
export default DnrScaleSmallAppearanceDefault;
